import { gql } from "lib/apolloClient";
import { gradebookInfoFragment } from "./PPGradebookTableFragments";

export const getPPGradebookProjectGroupStudentsWithProjectsQuery = gql`
  query getPPGradebookProjectGroupStudentsWithProjects(
    $id: ID!
    $projectGradebookFilters: ProjectGroupProjectsFilters
    $projectFieldFilters: PlannerFieldFilter
    $filtersForGeneric: ibPYPElementRatingFiltersForGeneric
    $academicYearId: ID
  ) {
    node(id: $id, type: PROJECT_GROUP) {
      ... on ProjectGroup {
        id
        projects(filters: $projectGradebookFilters) {
          totalCount
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              ...gradebookInfo
            }
          }
        }
      }
    }
  }
  ${gradebookInfoFragment}
`;
